import {getPatternLength} from 'engine/BouncingEngine.js';
import {insertEvent} from 'session/operations/actions.js';
import PatternSwitchEvent from 'session/PatternSwitchEvent.js';

export const getTrackLength = (sequencerEngine) => {
    if (sequencerEngine.mixes.every(m => m.length === 0)) {
        // then create a new mix
        for (let subSequence of sequencerEngine.subSequences) {
            sequencerEngine.switchToSubSequence(subSequence.id);
            let step = 0;
            let mix = subSequence.mix;
            let track = subSequence.tracks[0];
            if (!track) {
                continue;
            }
            let numPatterns = track.patterns.length;
            let tracks = subSequence.tracks;

            for (let patternNumber=0; patternNumber < numPatterns; patternNumber++) {
                let len = getPatternLength(sequencerEngine, patternNumber, tracks) * 4;
                let event = new PatternSwitchEvent(patternNumber);
                event.step = step;
                mix.dispatch(insertEvent(event, len));
                step += len;
            }
        }
    }

    let bars = Math.max(
        8,
        Math.max(... sequencerEngine.mixes.map(m => m.length/32.0 + 16)));

    console.log("NUM BARS = ", bars);
    return Math.floor(bars);
};
